import React from 'react'

const ViewListing = () => {
  return (
    <div>ViewListing</div>
  )
}

export default ViewListing